/**
 * Storage Types
 *
 * Types for Supabase Storage file upload, download, and management.
 */

/**
 * Represents a file stored in Supabase Storage
 */
export interface StorageFile {
  id: string;
  name: string;
  size: number;
  mimeType: string;
  bucket: string;
  path: string;
  publicUrl?: string;
  createdAt: string;
  updatedAt: string;
  metadata?: Record<string, string>;
}

/**
 * Options for file upload operations
 */
export interface UploadOptions {
  bucket?: string;
  path?: string;
  upsert?: boolean;
  contentType?: string;
  cacheControl?: string;
  metadata?: Record<string, string>;
  onProgress?: (progress: UploadProgress) => void;
}

/**
 * Progress information during file upload
 */
export interface UploadProgress {
  loaded: number;
  total: number;
  percentage: number;
}

/**
 * Result of an upload operation
 */
export interface UploadResult {
  success: boolean;
  file?: StorageFile;
  error?: string;
  publicUrl?: string;
}

/**
 * Storage bucket identifiers
 */
export type StorageBucket = 'dataroom' | 'pitch-decks' | 'submission-decks' | 'avatars';

/**
 * Storage bucket configuration
 */
export const STORAGE_BUCKETS: Record<StorageBucket, { name: string; public: boolean }> = {
  dataroom: { name: 'dataroom', public: false },
  'pitch-decks': { name: 'pitch-decks', public: false },
  'submission-decks': { name: 'submission-decks', public: false },
  avatars: { name: 'avatars', public: true },
};

/**
 * Result from expo-document-picker
 */
export interface FilePickResult {
  uri: string;
  name: string;
  size?: number;
  mimeType?: string;
}
